import React from "react";

import { Col, Container, Row } from "react-bootstrap";

import { PublicHeaderMinimal } from "@pages/public/PublicHeaderMinimal";

import styles from "./HowToUseTemplate.module.scss";

export const HowToUseTemplate = () => {
  return (
    <>
      <PublicHeaderMinimal />

      <Container className="py-5">
        <div className={styles["how-to-use-template"]}>
          <Row className="pb-4">
            <Col>
              <h2>How to use the template</h2>
            </Col>
          </Row>
          <Row className="pb-4">
            <Col>
              <p>
                Please complete one line on the spreadsheet for each resale. Some columns are mandatory. Please review
                this information to help you fill out the spreadsheet accurately.
              </p>
              <p>
                Artist given and family names are mandatory. If you don’t know a name, use “unknown”. Artist middle name
                is optional. If you don’t know it, leave it blank.
              </p>
              <ul>
                <li>
                  <strong>Pseudonym</strong> is optional. If you don’t know it, leave it blank.
                </li>
                <li>
                  <strong>Country</strong> is mandatory. Advise the country that the artist is a citizen/national or
                  permanent resident of.
                </li>
                <li>
                  <strong>Artist living</strong> is mandatory. Advise “yes”, “no”, or “unknown”.
                </li>
                <li>
                  <strong>Year of birth</strong> is mandatory. Use the format YYYY.
                </li>
                <li>
                  <strong>Year of death</strong> is mandatory if the artist is deceased. Use the format YYYY.
                </li>
                <li>
                  <strong>Title</strong> is mandatory. If you don’t know it, use “unknown”.
                </li>
                <li>
                  <strong>Medium</strong> is mandatory. Select one of:
                  <ul>
                    <li>Painting</li>
                    <li>Ceramic</li>
                    <li>Art Jewellery</li>
                    <li>Multimedia Artwork</li>
                    <li>Sculpture</li>
                    <li>Artists’ Book</li>
                    <li>Digital Artwork</li>
                    <li>Glassware</li>
                    <li>Photograph</li>
                    <li>Tapestry</li>
                    <li>Batik</li>
                    <li>Drawing</li>
                    <li>Installation</li>
                    <li>Picture</li>
                    <li>Video Artwork</li>
                    <li>Carving</li>
                    <li>Engraving</li>
                    <li>Lithograph</li>
                    <li>Print</li>
                    <li>
                      Other-use this if you don’t know how to classify it. Provide more details in the “Details” column.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Dimensions</strong> are optional. If you know the height and width in centimeters, enter them
                  as numerals only (to one decimal place).
                </li>
                <li>
                  <strong>Details</strong> are optional. If you selected “other” for the medium, provide more details
                  here.
                </li>
                <li>
                  <strong>Seller acquired work after 8 June 2010</strong> is mandatory. Advise “yes”, “no”, “unknown”,
                  “primary sale” or “voluntary sale”.
                  <ul>
                    <li>If you advise “unknown”, we may contact you for further information.</li>
                    <li>
                      A “voluntary sale” means that you acquired the work before 9 June 2010, but you wish to
                      participate in the scheme and pay a voluntary royalty.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Sale price</strong> is mandatory. Enter numerals only, inclusive of GST.
                </li>
                <li>
                  <strong>Date sold</strong> is mandatory. Use the format DD/MM/YYYY.
                </li>
                <li>
                  <strong>Artist Work ID</strong> is optional. Include any artist identification you have.
                </li>
                <li>
                  <strong>Gallery Work ID</strong> is optional. If you have a reference number, include it here.
                </li>
              </ul>
              <p>
                Copyright Agency requires sufficient information to determine whether the resale royalty is payable, and
                the amount of the resale royalty. The mandatory fields in this template are the minimum we require to
                make this assessment.
              </p>
            </Col>
          </Row>

          {/* Definitions Section */}
          <Row className="pb-4">
            <Col>
              <h4>Definitions of terms used and helpful information</h4>
              <ul>
                <li>
                  <strong>Acquire:</strong> includes a gift, inheritance, or purchase.
                </li>
                <li>
                  <strong>Artist living:</strong> The resale royalty applies to works sold during an artist’s lifetime
                  and for 70 years after the end of the year of the artist’s death.
                </li>
                <li>
                  <strong>Country:</strong> The legislation applies to Australian citizens, permanent residents of
                  Australia and nationals or citizens of reciprocating countries.
                </li>
                <li>
                  <strong>Pseudonym:</strong> The fictitious name commonly used by the artist. by which the artist is
                  known.
                </li>
                <li>
                  <strong>Reciprocating country:</strong> The legislation allows for reciprocal agreements with other
                  countries. On 31 March 2024,the resale royalty scheme expend to 17 reciprocating countries, including
                  the UK and many European countries.
                </li>
                <li>
                  <strong>Sale price:</strong> The resale royalty applies to works of a value of $1,000 and above,
                  including GST.
                </li>
              </ul>
            </Col>
          </Row>
          {/* Save File Instructions */}
          <Row className="pb-5">
            <Col>
              <h4>How to save your file</h4>
              <p>
                You must save your spreadsheet as an excel file. The file name must use a{" "}
                <strong>.csv file extension</strong>. Example: <code>ResalesFileName.csv</code>
              </p>
              <p>Maximum file size is 10MB.</p>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};
